import { initReactI18next } from 'react-i18next'
import i18next from 'i18next'
// import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

import englishTranslation from './translation/English/translation.json'
import portugueseTranslation from './translation/Portuguese/translation.json'

const resources = {
  en: {
    translation: englishTranslation
  },
  pt: {
    translation: portugueseTranslation
  }
}

const DETECTION_OPTIONS = {
  order: ['localStorage', 'navigator'],
  caches: ['localStorage']
}

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: DETECTION_OPTIONS,
    resources,
    fallbackLng: 'en'
  })

export default i18next

export const translate = (key: string) => i18next.t(key)
